var $2eed782c1c110ce7$exports = {};
$2eed782c1c110ce7$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " non selezionato.");
  },
  "longPressToSelect": "Premi a lungo per passare alla modalit\xE0 di selezione.",
  "select": "Seleziona",
  "selectedAll": "Tutti gli elementi selezionati.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nessun elemento selezionato",
      one: function one() {
        return "".concat(formatter.number(args.count), " elemento selezionato");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementi selezionati");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " selezionato.");
  }
};
export { $2eed782c1c110ce7$exports as default };